module.exports = __webpack_public_path__ + "static/UT_2P_modern_v2-50ab87f20ccca971417425440c1b5b8a.png";